import { render, staticRenderFns } from "./BS.vue?vue&type=template&id=68bd9d7b&scoped=true"
import script from "./BS.vue?vue&type=script&lang=js"
export * from "./BS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd9d7b",
  null
  
)

export default component.exports